<div class="wrapper d-flex align-items-stretch">
  <ozm-sidebar></ozm-sidebar>

  <div id="content" class="p-4 p-md-5">
    <div class="tp-wr mt-3">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <!-- Header Section -->
            <div class="favorites-header mb-4">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h2><i class="fas fa-heart text-danger"></i> My Favorite Apps</h2>
                  <p class="text-muted">Manage your favorite applications</p>
                </div>
                <div>
                  <button class="btn btn-primary" (click)="navigateToCategories()">
                    <i class="fas fa-plus"></i> Add More Apps
                  </button>
                </div>
              </div>
              
              <!-- Stats -->
              <div class="row mt-3">
                <div class="col-md-3">
                  <div class="stat-card">
                    <div class="stat-number">{{ userFavoriteApps.length }}</div>
                    <div class="stat-label">Total Favorites</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="stat-card">
                    <div class="stat-number">{{ getCategoryNames().length }}</div>
                    <div class="stat-label">Categories</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Loading State -->
            <div class="loading-container text-center" *ngIf="loading">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <p class="mt-2">Loading your favorite apps...</p>
            </div>

            <!-- Empty State -->
            <div class="empty-state text-center" *ngIf="!loading && userFavoriteApps.length === 0">
              <div class="empty-icon">
                <i class="fas fa-heart-broken fa-4x text-muted"></i>
              </div>
              <h3 class="mt-3">No Favorite Apps Yet</h3>
              <p class="text-muted">You haven't added any apps to your favorites.</p>
              <button class="btn btn-primary btn-lg" (click)="navigateToCategories()">
                <i class="fas fa-plus"></i> Browse Apps
              </button>
            </div>

            <!-- Favorites Content -->
            <div class="favorites-content" *ngIf="!loading && userFavoriteApps.length > 0">
              <!-- Category-wise apps -->
              <div class="category-section" *ngFor="let categoryName of getCategoryNames()">
                <div class="category-header">
                  <h4><i class="fas fa-folder"></i> {{ categoryName }}</h4>
                  <span class="category-count">{{ getAppsByCategory()[categoryName].length }} apps</span>
                </div>
                
                <div class="row">
                  <div class="col-xl-3 col-lg-4 col-md-6 mb-4" 
                       *ngFor="let app of getAppsByCategory()[categoryName]">
                    <div class="favorite-app-card">
                      <div class="app-image">
                        <img [src]="getAppIcon(app)" 
                             [alt]="app.name"
                             (error)="onImageError($event)">
                      </div>
                      
                      <div class="app-details">
                        <h5 class="app-name">{{ app.name }}</h5>
                        <p class="app-category">
                          <small class="text-muted">
                            <i class="fas fa-tag"></i> {{ getDisplayCategoryName(app) }}
                            <span *ngIf="app.subCategory"> / {{ getDisplaySubcategoryName(app) }}</span>
                          </small>
                        </p>
                        <p class="app-date">
                          <small class="text-muted">
                            <i class="fas fa-calendar"></i> Added {{ app.dateAdded | date:'MMM dd, yyyy' }}
                          </small>
                        </p>
                      </div>
                      
                      <div class="app-actions">
                        <button class="btn btn-primary btn-sm" 
                                (click)="openApp(app)"
                                [disabled]="!app.link"
                                title="Open App">
                          <i class="fas fa-external-link-alt"></i> Open
                        </button>
                        <button class="btn btn-outline-danger btn-sm" 
                                (click)="removeFromFavorites(app)"
                                title="Remove from Favorites">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
